import { render } from "./VitBreadcrumbs.vue?vue&type=template&id=022abd21&ts=true"
import script from "./VitBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./VitBreadcrumbs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__